export const newsSourceMapping: Record<string, string> = {
  'www.zf.ro': 'Ziarul Financiar',
  'zf.ro': 'Ziarul Financiar',
  'www.wall-street.ro': 'Wall-street.ro',
  'wall-street.ro': 'Wall-street.ro',
  'www.agerpres.ro': 'Agerpres',
  'agerpres.ro': 'Agerpres',
  'www.profit.ro': 'PROFIT.ro',
  'profit.ro': 'PROFIT.ro',
  'www.economica.net': 'Economica.net',
  'economica.net': 'Economica.net',
  'www.economedia.ro': 'Economedia.ro',
  'economedia.ro': 'Economedia.ro',
  'www.bursa.ro': 'Bursa.ro',
  'bursa.ro': 'Bursa.ro',
};

export function getDisplaySource(source: string): string {
  // Extract domain from URL if source is a URL
  let domain = source;
  try {
    const url = new URL(source);
    domain = url.hostname;
  } catch {
    // If it's not a valid URL, use the source as is
  }

  // Return mapped name or domain (not full URL)
  return newsSourceMapping[domain] || domain;
}
